var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 7.98428L12.5283 4.18195C11.6457 3.49534 10.4097 3.49534 9.52709 4.18195L4.63759 7.98428C4.04212 8.44735 3.69398 9.15954 3.69434 9.91386V16.5139C3.69434 17.5264 4.51515 18.3472 5.52767 18.3472H16.5277C17.5402 18.3472 18.361 17.5264 18.361 16.5139V9.91386C18.361 9.15945 18.0127 8.4472 17.4168 7.98428",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 13.7501C12.641 14.972 9.3575 14.972 7.3335 13.7501",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.487f8a5ff180cca42e893d33e211e57e.svg";
export { ForwardRef as ReactComponent };